// export const LOGIN = "http://10.20.1.5:8092/auth/login"
// export const  ISAUTH = "http://10.20.1.5:8092/auth/isauth?token"
// export const UPLOADIMG = "http://10.20.1.5:8092/api/v1/uploadImg"
// export const PACKAGE = "http://10.20.1.5:8092/api/v1/package"
// export const COUNTRY = "http://10.20.1.5:8092/api/v1/country"
// export const COUNTRYLOCATION = "http://10.20.1.5:8092/api/v1/countryLocation"
// export const PACKAGETYPE = "http://10.20.1.5:8092/api/v1/pkgType"
// export const FEATURES = "http://10.20.1.5:8092/api/v1/feature"
// export const BLOG = "http://10.20.1.5:8092/api/v1/blog"
// export const USER = "http://10.20.1.5:8092/api/v1/user"
// export const VACATIONTYPE = "http://10.20.1.5:8092/api/v1/vacationType"
// export const LEADSCOUNT = "http://10.20.1.5:8092/api/v1/leadCount"
// export const LEADS = "http://10.20.1.5:8092/api/v1/leads"      
// export const LEADSFILTER = "http://10.20.1.5:8092/api/v1/leadsFromDateFilter"
// export const PACKAGEEDITONE = "http://10.20.1.5:8092/api/v1/package"
// export const OFFER = "http://10.20.1.5:8092/api/v1/offer"

// export const API = "https://www.10.20.1.5:8092/api/api/v1"



// Live Credentials.
export const API = "https://www.99tripsdeal.com/api/api/v1"

export const LOGIN = "https://www.99tripsdeal.com/api/auth/login"
export const ISAUTH = "https://www.99tripsdeal.com/api/auth/isauth?token"
export const UPLOADIMG = "https://www.99tripsdeal.com/api/api/v1/uploadImg"
export const PACKAGE = "https://www.99tripsdeal.com/api/api/v1/package"
export const COUNTRY = "https://www.99tripsdeal.com/api/api/v1/country"
export const COUNTRYLOCATION = "https://www.99tripsdeal.com/api/api/v1/countryLocation"
export const PACKAGETYPE = "https://www.99tripsdeal.com/api/api/v1/pkgType"
export const FEATURES = "https://www.99tripsdeal.com/api/api/v1/feature"
export const BLOG = "https://www.99tripsdeal.com/api/api/v1/blog"
export const USER = "https://www.99tripsdeal.com/api/api/v1/user"
export const VACATIONTYPE = "https://www.99tripsdeal.com/api/api/v1/vacationType"
export const LEADSCOUNT = "https://www.99tripsdeal.com/api/api/v1/leadCount"
export const LEADS = "https://www.99tripsdeal.com/api/api/v1/leads"
export const LEADSFILTER = "https://www.99tripsdeal.com/api/api/v1/leadsFromDateFilter"
export const PACKAGEEDITONE = "https://www.99tripsdeal.com/api/api/v1/package"
export const OFFER = "https://www.99tripsdeal.com/api/api/v1/offer"
export const BLOGURL = "https://www.99tripsdeal.com/api/api/web/v1/blog?titleUrl"
export const BOOKING = "booking"



